/**
 * decodes html chars to normal string
 * https://stackoverflow.com/a/7394787/2519073
 * @param html html string to decode
 */
export function decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    const result = txt.value;
    txt.remove();
    return result;
}
